export const PartnershipTypeOptions = Object.freeze([
    { label: "General", value: "General" },
    { label: "Limited", value: "Limited" },
    { label: "Limited Liability Partnership (LLP)", value: "Limited Liability Partnership (LLP)" }
]);